"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeGlobalClass = removeGlobalClass;
exports.addGlobalClass = addGlobalClass;
exports.hasGlobalClass = hasGlobalClass;

/**
 * Global classes (to prevent scrolling for lightboxes and modals) must be added to
 * the documentElement and the body
 */
function removeGlobalClass(CLASS) {
  if (typeof document !== 'undefined') {
    document.body.classList.remove(CLASS);
    document.documentElement.classList.remove(CLASS);
  }
}

function addGlobalClass(CLASS) {
  if (typeof document !== 'undefined') {
    document.body.classList.add(CLASS);
    document.documentElement.classList.add(CLASS);
  }
}

function hasGlobalClass(Class) {
  return typeof document !== 'undefined' && (document.body.classList.contains(Class) || document.documentElement.classList.contains(Class));
}


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/util/globalClass.js
// module id = 507
// module chunks = 0